type EventName = string
type EventListener<T = any> = (data: T) => void

interface IEventBus {
    on<T = any>(eventName: EventName, listener: EventListener<T>): void;
    emit<T = any>(eventName: EventName, data: T): void;
    off<T = any>(eventName: EventName, listener?: EventListener<T>): void;
}

class EventBus implements IEventBus {
    private listeners: { [eventName: string]: EventListener[] } = {};

    on<T = any>(eventName: string, listener: EventListener<T>): void {
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
        }
        this.listeners[eventName].push(listener);
    }
    emit<T = any>(eventName: string, data: T): void {
        if (this.listeners[eventName]) {
            this.listeners[eventName].forEach(listener => listener(data));
        }
    }
    off<T = any>(eventName: string, listener?: EventListener<T> | undefined): void {
        if (this.listeners[eventName]) {
            if (listener) {
                this.listeners[eventName] = this.listeners[eventName].filter(l => l !== listener);
            } else {
                // 如果没有指定listener，则移除所有监听器
                delete this.listeners[eventName];
            }
        }
    }
}
const globalEventBus = new EventBus();
export default globalEventBus;